import { groupPosts, groupPostsReply } from '@/utils/groupPosts';

import { getActiveTab } from '../../utils/activeTabUtils.js';

export default {
  setPosts(state, payload) {
    state.recomendedPosts = payload;
  },

  async setRecomendedPosts(state, payload) {
    if (!state || !payload) return;
    state.recomendedPosts = await groupPosts(payload);
  },
  async setFollowingPosts(state, { payload, postType }) {
    if (!state || !payload) return;
    state.followingPosts = await groupPosts(payload);
    if (postType === '&type=reply') {
      state.followingPosts = groupPostsReply(state.followingPosts);
    }
  },
  // setPostsForyou(state, { collection, posts }) {
  //   if (state[collection]) {
  //     state[collection] = posts;
  //   }
  // },
  setReportBotId(state, id) {
    state.reportId = id;
  },
  setPostsSuggested(state, payload) {
    state.suggestedPosts = payload;
  },
  setPost(state, payload) {
    state.recomendedPost = payload;
  },

  setRepliePost(state, payload) {
    state.replies = payload;
  },

  async postPost(state, payload) {
    state.post = payload.data;
    const activeTab = getActiveTab();
    if (activeTab && activeTab.collection) {
      if (!state[activeTab.collection]) {
        state[activeTab.collection] = [];
      }
      if (payload.type === 'create') {
        if (activeTab.collection === 'positive') {
          state.positive.unshift(state.post);
          if (state.negative && state.negative[0]) {
            state.negative.unshift(state.post);
          }
        }
        if (activeTab.collection === 'negative') {
          state.negative.unshift(state.post);
          if (state.positive && state.positive[0]) {
            state.positive.unshift(state.post);
          }
        }
        if (activeTab.collection !== 'negative' && activeTab.collection !== 'positive') {
          if (
            payload.data.type !== 'reply' &&
            activeTab.collection !== 'userReplies' &&
            activeTab.collection !== 'userReposts'
          ) {
            state[activeTab.collection].unshift(state.post);
          }
          if (
            activeTab.collection === 'userReplies' ||
            activeTab.collection === 'userReposts' ||
            !activeTab.collection
          ) {
            state.onlyUserPosts.unshift(state.post);
          }
          if (state.positive && state.positive[0]) {
            state.positive.unshift(state.post);
          }
          if (state.negative && state.negative[0]) {
            state.negative.unshift(state.post);
          }
        }
      }
      if (payload.type === 'update') {
        if (activeTab.collection === 'recomendedPosts' || activeTab.collection === 'followingPosts') {
          let index = await state[activeTab.collection].findIndex(el =>
            el.isCarousel ? el.posts.some(post => post.id === state.post.id) : el.id === state.post.id,
          );
          if (index !== -1) {
            if (state[activeTab.collection][index].isCarousel) {
              const postIndex = state[activeTab.collection][index].posts.findIndex(post => post.id === state.post.id);
              state[activeTab.collection][index].posts[postIndex] = state.post;
            } else {
              state[activeTab.collection].splice(index, 1, state.post);
            }
          }
        }
        if (activeTab.collection === 'positive') {
          let indexP = await state.positive.findIndex(el => el.id === state.post.id);
          let indexN = await state.negative.findIndex(el => el.id === state.post.id);
          state[activeTab.collection].splice(indexP, 1, state.post);
          if (indexN !== -1) {
            state.negative.splice(indexN, 1, state.post);
          }
        }
        if (activeTab.collection === 'negative') {
          let indexN = await state.negative.findIndex(el => el.id === state.post.id);
          let indexP = await state.positive.findIndex(el => el.id === state.post.id);
          state[activeTab.collection].splice(indexN, 1, state.post);
          if (indexP !== -1) {
            state.positive.splice(indexP, 1, state.post);
          }
        }
        if (state.onlyUserPosts) {
          const index = state.onlyUserPosts.findIndex(post => post.id === state.post.id);
          if (index !== -1) {
            state.onlyUserPosts.splice(index, 1, state.post);
          }
        }
      }
    }
    if (payload.data.type === 'reply') {
      const index = state.replies.findIndex(reply => reply.id === payload.data.id);
      if (index !== -1) {
        state.replies.splice(index, 1, payload.data);
      }
    }
  },

  removePost(state, postId) {
    try {
      const activeTab = getActiveTab();
      if (!activeTab) {
        console.warn('Remove post: Active tab not found');
        return;
      }

      const collection = state[activeTab.collection];
      if (!collection) {
        console.warn('Remove post: Collection not found');
        return;
      }

      if (Array.isArray(collection)) {
        state[activeTab.collection] = collection.filter(item => {
          if (item?.isCarousel) {
            item.posts = item.posts?.filter(post => post?.id !== postId);
            return item.posts?.length > 0;
          }
          return item?.id !== postId;
        });
      } else {
        delete collection[postId];
      }
    } catch (error) {
      console.error('Error removing post:', error);
    }
  },

  async setCollection(state, { collectionName, data, isReply }) {
    if (Array.isArray(state[collectionName])) {
      if (collectionName === 'recomendedPosts' || collectionName === 'followingPosts') {
        let groupedPosts = await groupPosts(data);
        if (isReply?.type === 'Reply') {
          groupedPosts = groupPostsReply(groupedPosts);
        }
        state[collectionName] = [...state[collectionName], ...groupedPosts];
      } else {
        state[collectionName] = [...state[collectionName], ...data];
      }
    } else {
      state[collectionName] = [...data];
    }
  },

  updateNow(state) {
    state.now = new Date();
  },
  setProfile(state, profile) {
    state.profile = profile;
  },
  setUserReplies(state, replies) {
    state.userReplies = replies;
  },
  setUserReposts(state, reposts) {
    state.userReposts = reposts;
  },
  setOnlyUserPosts(state, posts) {
    state.onlyUserPosts = posts;
  },

  setReputationCategories(state, categories) {
    state.reputationCategories = categories;
  },
  setStatusLoad(state, payload) {
    state.loadStatus = payload;
  },
  setIsReply(state, isReply) {
    state.isReply = isReply;
  },
  setUsernameData(state, data) {
    state.usernameData = data;
  },
  removeReportedPost(state, id) {
    if (Array.isArray(state.recomendedPosts)) {
      state.recomendedPosts = state.recomendedPosts.filter(post => post.id !== id);
    }
  },

  removeReportedPostWithCollection(state, { postId, collectionName }) {
    if (!state[collectionName]) {
      console.warn(`Collection "${collectionName}" does not exist.`);
      return;
    }
    state.collections[collectionName] = state.collections[collectionName].filter(post => post.id !== postId);
  },

  setReaction(state, payload) {
    state.replies = state.replies.map(post => (post.id === payload.id ? payload : post));
  },
  addReplyPostStatus(state, status) {
    state.replyPostStatus = status;
  },
  setTotalCountPosts(state, count) {
    state.totalCountPosts = count;
  },
  // setBlockOnReplies(state, blockedUsersIds) {
  //   state.replies.splice(
  //     0,
  //     state.replies.length,
  //     ...state.replies.filter((reply) => !blockedUsersIds.includes(reply.authorUserId))
  //   );
  // },
  setSearchText(state, text) {
    state.searchText = text;
  },
  setSearchResults(state, { users, posts }) {
    state.searchResults.users = users;
    state.searchResults.posts = posts;
  },
  setNoSearchResults(state, query) {
    state.noSearchResults = query;
  },
  clearSearchResults(state) {
    state.searchResults = { users: [], posts: [] };
  },
  clearCollection(state, collectionName) {
    if (state[collectionName]) {
      state[collectionName] = [];
    }
  },
  setUnreadPosts(state, posts) {
    state.unreadPosts = posts;
  },
  setIntroPosts(state, posts) {
    state.introPosts = posts;
  },
};
